import UtilsFncs from "utils/UtilsFncs";

export default function buildPrePedidosQueryParams(filters, { page = 0, pageSize = 25 } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });

  if (filters?.vitrineName?.trim()) {
    params.set("nome", filters.vitrineName.trim());
  }
  if (filters?.cnpj?.trim()) {
    params.set("cnpj", filters.cnpj.trim());
  }
  if (filters?.dataPrePedidoInicio) {
    params.set(
      "dataPrePedidoInicio",
      UtilsFncs.ConvertDateFormat(filters.dataPrePedidoInicio, "-", "-"),
    );
  }
  if (filters?.dataPrePedidoFim) {
    params.set(
      "dataPrePedidoFim",
      UtilsFncs.ConvertDateFormat(filters.dataPrePedidoFim, "-", "-"),
    );
  }

  return params;
}
